import { render, staticRenderFns } from "./EmployeeCreate.vue?vue&type=template&id=72f0c234&scoped=true&"
import script from "./EmployeeCreate.vue?vue&type=script&lang=js&"
export * from "./EmployeeCreate.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeCreate.vue?vue&type=style&index=0&id=72f0c234&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f0c234",
  null
  
)

export default component.exports